__turbopack_context__.v({
  "error": "EmailCaptureForm-module__xcKuka__error",
  "form": "EmailCaptureForm-module__xcKuka__form",
  "heading": "EmailCaptureForm-module__xcKuka__heading",
  "input": "EmailCaptureForm-module__xcKuka__input",
  "privacy": "EmailCaptureForm-module__xcKuka__privacy",
});
